import { ButtonBase, styled } from "@mui/material";

export const DashedButton = styled(ButtonBase)(({ theme }) => ({
	marginTop: theme.spacing(theme.spacingTokens.sm),
	width: "100%",
	padding: theme.spacing(theme.spacingTokens.md, theme.spacingTokens.lg),
	border: `1px dashed ${theme.palette.grey[300]}`,
	borderRadius: theme.radii.lg,
	justifyContent: "flex-start",
	textAlign: "left",
}));
